import * as types from "./upload.actionTypes";
import { takeEvery, put, select } from "redux-saga/effects";
import uploadActions from "./upload.actions";
import uploadSelector from "./upload.selectors";

export default workSaga;

function* workSaga() {
    yield takeEvery(types.SET_ANEXOS_SAGA, setAnexos);
    yield takeEvery(types.SET_ANEXOS_CUSTOMIZADOS_SAGA, setAnexosCustomizados);
    yield takeEvery(types.CHANGE_ANEXO, changeAnexo);
    yield takeEvery(types.CHANGE_TEXT_ANEXO, changeTextAnexo);
    yield takeEvery(types.DELETE_ANEXO, deleteAnexo);
    yield takeEvery(types.ADD_ANEXO_CUSTOMIZADO, addAnexoCustomizado);
}

function* setAnexos(action) {
    const { payload } = action;

    let documento = yield select(uploadSelector.upload);

    let { anexos } = documento;

    let mergeAnexos = anexos.map(anexo => {
        let anexoCorrespondente;

        payload.forEach(anexoPayload => {
            if (anexo.TipoAnexo.Id === anexoPayload.TipoAnexo.Id) anexoCorrespondente = anexoPayload;
        });

        let anexoFinal = anexoCorrespondente || anexo;

        return { ...anexoFinal, Valor: { name: anexoFinal.NomeArquivo } };
    })

    yield put(uploadActions.setAnexos(mergeAnexos));
}

function* setAnexosCustomizados(action) {
    const { payload } = action;

    const anexosCustomizados = payload.map(anexo => {
        return { ...anexo, Valor: { name: anexo.NomeArquivo } }
    });

    yield put(uploadActions.setAnexosCustomizado(anexosCustomizados));
}

function* changeTextAnexo(action) {
    const { payload } = action;

    const { text, index } = payload;

    let documento = yield select(uploadSelector.upload);

    const { anexosCustomizado } = documento;

    const anexosCustomizadoArray = [...anexosCustomizado];

    let isUpdate = !!anexosCustomizadoArray[index].Caminho;

    let obj = { ...anexosCustomizadoArray[index], Descricao: text, isUpdate };

    anexosCustomizadoArray[index] = obj;

    yield put(uploadActions.setAnexosCustomizado(anexosCustomizadoArray));
}

function* addAnexoCustomizado() {
    let documento = yield select(uploadSelector.upload);

    const { anexosCustomizado } = documento;

    let objCustomizado = {
        ...anexosCustomizado[0],
        Id: undefined,
        Valor: undefined,
        Descricao: undefined,
        NomeArquivo: undefined,
        Caminho: undefined,
        isNew: true,
        TipoAnexo: { ...anexosCustomizado[0].TipoAnexo, DDados: { ...anexosCustomizado[0].TipoAnexo.DDados, Name: `AnexoCustomizado_${anexosCustomizado.length}` } }
    };

    let anexosCustomizadoArray = [...anexosCustomizado, objCustomizado]

    yield put(uploadActions.setAnexosCustomizado(anexosCustomizadoArray));
}

function* deleteAnexo(action) {
    const { payload } = action;

    const { arrayName, index } = payload;

    let documento = yield select(uploadSelector.upload);

    if (arrayName == "anexosCustomizado") {
        const { anexosCustomizado } = documento;

        let anexosArray = [];

        if (anexosCustomizado[index].Caminho) {
            anexosArray = [...anexosCustomizado];

            let anexoObjeto = yield setDeleteIndexInArray(anexosCustomizado, index)

            anexosArray[index] = anexoObjeto;
        } else {
            anexosArray = [...anexosCustomizado].filter((_anexo, _index) => _index != index)
        }
        yield put(uploadActions.setAnexosCustomizado(anexosArray));
    }
}

function* setDeleteIndexInArray(array, index) {
    return { ...array[index], isDelete: true, isNew: false, isUpdate: false, isDeleteFromScreen: true };
}

function* changeAnexo(action) {
    const { payload } = action;

    const { arrayName, index, anexo } = payload;

    let documento = yield select(uploadSelector.upload);

    if (arrayName == "anexos") {
        const { anexos } = documento;

        let anexoArray = [...anexos];

        let anexoObjeto = yield addValuetoAnexo(anexos, index, anexo);

        anexoArray[index] = anexoObjeto;
        yield put(uploadActions.setAnexos(anexoArray));
    }

    if (arrayName == "anexosCustomizado") {
        const { anexosCustomizado } = documento;

        let anexosCustomizadoArray = [...anexosCustomizado];

        let anexoCustomizadoObjeto = yield addValuetoAnexo(anexosCustomizado, index, anexo);

        anexosCustomizadoArray[index] = anexoCustomizadoObjeto;
        yield put(uploadActions.setAnexosCustomizado(anexosCustomizadoArray));
    }
}

function* addValuetoAnexo(array, index, anexo) {
    let isDelete = (!anexo && !!array[index].Caminho);

    let isUpdate = !isDelete && !!array[index].Caminho;

    let isNew = !isDelete && !isUpdate;

    return { ...array[index], NomeArquivo: anexo ? anexo.name : "", Valor: anexo, isDelete, isUpdate, isNew };
}